export default __webpack_public_path__ + "static/media/pixagriLogoV2.fbd8680c.svg";